import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateAgencies } from '@/modules/Agency/gql/agency.gql'
import { Agency } from '@/modules/Agency/interfaces/agency'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchAgency extends Vue {
  candidatesAgency: Agency[] = []

  get candidatesAgencyOptions () {
    return this.candidatesAgency.map(item => {
      return {
        ...item,
        id: +item.id
      }
    })
  }

  async mounted () {
    this.getCandidateAgencies()
  }

  async getCandidateAgencies (val?: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateAgencies,
        variables: {
          filter: {
            name: val
          },
          paging: {
            offset: 0,
            limit: -1
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesAgency = this.$R.sortBy(this.$R.compose(this.$R.toLower, this.$R.prop('name')))(result.data.getAgencies.agencies)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
